import { useCategoryPageScroll } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageScroll";
import { CategoryPageFiltersAndContent } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/FiltersAndContent/CategoryPageFiltersAndContent";
import React from "react";

export const LoggedInCategoryPageContent = ({
  pageLoadTimingRef,
  className,
}: {
  pageLoadTimingRef: React.Ref<HTMLDivElement> | undefined;
  className?: string;
}) => {
  const { scrollToTop, scrollRef, filterRef } = useCategoryPageScroll();

  return (
    <CategoryPageFiltersAndContent
      pageLoadTimingRef={pageLoadTimingRef}
      filterRef={filterRef}
      scrollRef={scrollRef}
      scrollToTop={scrollToTop}
      className={className}
    />
  );
};
